import * as React from 'react';

import styled from 'styled-components';

import PreOrderAppleIcon from './pre-order-apple';
import PreOrderAmazonIcon from './pre-order-amazon';
import PreOrderYouTubeIcon from './pre-order-youtube';

export const PreOrderShopIcons = () => (
  <Wrapper>
    <PreOrderAppleIcon />
    <PreOrderYouTubeIcon />
    <PreOrderAmazonIcon />
  </Wrapper>
);

export default PreOrderShopIcons;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
`;
